import { CustomerIcon, RestPinIconSelected, RestPinIconUnselected } from './icons';
import React from 'react';
import { GMapReact } from './Maps';

export function BranchSelectorGMap(props) {
  const { customerLocation, branches, selectedBranch, onSelectBranch } = props;

  const markups = branches.map((branch, index) => {
    return {
      latLng: branch.latLng,
      icon:
        selectedBranch === index ? (
          <RestPinIconSelected
            onClick={() => {
              onSelectBranch(branch.id);
            }}
          />
        ) : (
          <RestPinIconUnselected
            onClick={() => {
              onSelectBranch(branch.id);
            }}
          />
        ),
    };
  });

  markups.push({ latLng: customerLocation, icon: <CustomerIcon /> });
  return (
    <GMapReact
      markups={markups}
      zoom={11}
      center={customerLocation}
      origin={customerLocation}
      destination={branches[selectedBranch] && branches[selectedBranch].latLng} //todo masha check why no branches in test
    />
  );
}
